import { component, initialize } from 'tsdi';
import { makeAutoObservable } from 'mobx';
import { Field, Form } from '../../core/forms';
import { isE2e } from '../../core/api';
import { LOCALSTORAGE_COOKIES } from './index';

interface CookiesSetting {
    necessary: boolean;
    marketing: boolean;
}

@component
export class CookieNoticeStore {
    constructor() {
        makeAutoObservable(this);
        this.savedConfiguration = {
            marketing: false,
            necessary: false
        };
        this.showNotice = false;
    }

    public showNotice = false;

    public savedConfiguration: CookiesSetting = {
        necessary: true,
        marketing: false
    };

    public form = new Form({
        necessary: new Field(this.localStorageCookies.necessary),
        marketing: new Field(this.localStorageCookies.marketing)
    });

    public openCookieNotice = () => {
        this.showNotice = true;
    };

    private get localStorageCookies(): CookiesSetting {
        return JSON.parse(
            localStorage.getItem(LOCALSTORAGE_COOKIES) || 'false'
        );
    }

    public get marketingEventsEnabled() {
        return this.savedConfiguration.marketing;
    }

    @initialize
    public init(): void {
        if (isE2e()) {
            return;
        }

        const savedCookies: CookiesSetting = this.localStorageCookies;

        if (savedCookies) {
            this.savedConfiguration = savedCookies;
        } else {
            this.showNotice = true;
        }
    }

    public saveCookies = () => {
        const cookies = this.form.getModel();
        localStorage.setItem(LOCALSTORAGE_COOKIES, JSON.stringify(cookies));
        this.savedConfiguration = cookies;
        this.showNotice = false;
    };
}
